import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import BookingService from '../../api/services/BookingManually';
import MainPagetitle from '../../layouts/MainPagetitle';
import LogoAnimationLoader from '../Loading/LogoAnimationLoader';
import ReactFlagsSelect from "react-flags-select";
const EditBooking = () => {
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [bookingType, setBookingType] = useState([]);
  const [isLoading, setisloading] = useState(true);
  const [birthdate, setBirthdate] = useState('');
  const [birtherror, setBirtherrror] = useState('');
  const [selectedConutry, setSelectedCountry] = useState("");
  const params = useParams();
  const handleBirthdate = (e) => {

    let input = e.target.value;

    // Remove any non-digit characters
    input = input.replace(/\D/g, '');

    // Format the date as dd/mm/yyyy
    if (input.length <= 2) {
      setBirthdate(input);
    } else if (input.length <= 4) {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2)}`);
    } else {
      setBirthdate(`${input.slice(0, 2)}/${input.slice(2, 4)}/${input.slice(4, 8)}`);

    }

    const currentYear = new Date().getFullYear();
    const year = e.target.value.split("/")[2];
    const month = e.target.value.split("/")[1];
    const day = e.target.value.split("/")[0];
    const age = currentYear - year;
    if (month >= 13 || age < 21 || day >= 32) {
      setBirtherrror("You have to be at least 21 years old");
    }
    else {
      setBirtherrror("");
    }



  }
  useEffect(() => {
    getBookingType(params.id);

  }, []);
  // ----------- get Camper  ------------ //
  const getBookingType = async () => {
    try {
      let type = await BookingService.show(params.id).json();
      setBookingType(type.data);
      setSelectedCountry(type.data.country)
      setBirthdate(`${type.data.dob.slice(8, 11)}/${type.data.dob.slice(5, 7)}/${type.data.dob.slice(0, 4)}`);

      // setBirthdate(type.data.dob)
      setisloading(false);
    } catch (error) {
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }
  };


  const onSubmitForm = async (event) => {
    event.preventDefault();
    setError("")
    try {
      var userData = {
        "id": params.id,
        "name": event.target.name.value,
        "email": event.target.email.value,
        "dob": birthdate ? birthdate.slice(6, 11) + "-" + birthdate.slice(3, 5) + "-" + birthdate.slice(0, 2) : '',
        "phone": event.target.phone.value,
        "address": event.target.address.value,
        "street": event.target.street.value,
        "zip": event.target.zip.value,
        "city": event.target.city.value,
        "status": 1,
        "country": selectedConutry ? selectedConutry : '',
        "company": event.target.company.value,
        "vat_id": event.target.vat_id.value,

      }

      let responseData = await BookingService.update(params.id, userData).json()
      if (responseData.status === true) {

        navigate("/admin/booking");
      }
    } catch (error) {
      console.log(error)
      if (error.name === 'HTTPError') {
        const errorJson = await error.response.json();
        setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
      }
    }

  };

  return (
    <>
      <MainPagetitle mainTitle="Add Booking" pageTitle={'Add Booking'} parentTitle={'Home'} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">Add Booking</h4>
              </div>
              <div className="card-body">
                <form className="form-valide" onSubmit={onSubmitForm}>
                  <div className="row">
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >First & last name<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='name' id="val-username" placeholder="" defaultValue={bookingType.name} />

                    </div>

                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" > Email <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='email' id="val-username" placeholder="" defaultValue={bookingType.email} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Phone<span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='phone' id="val-username" placeholder="" defaultValue={bookingType.phone} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Date of birth<span className="text-danger">*</span></label>
                      <input
                        className="form-control"
                        type="text"
                        value={birthdate}
                        placeholder="DD/MM/YYYY" name="dob" onChange={handleBirthdate}
                      />
                      <div className="px-4 py-1 h-6 font-light"></div> {birtherror ? <p style={{ color: "red" }} >{birtherror}</p> : ''}
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Street <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='street' id="val-username" placeholder="" defaultValue={bookingType.street} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Address addition </label>
                      <input type="text" className="form-control" name='address' id="val-username" placeholder="" defaultValue={bookingType.address} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Zip  <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='zip' id="val-username" placeholder="" defaultValue={bookingType.zip} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >City  <span className="text-danger">*</span></label>
                      <input type="text" className="form-control" name='city' id="val-username" placeholder="" defaultValue={bookingType.city} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Country <span className="text-danger">*</span></label>
                      <ReactFlagsSelect
                        selected={selectedConutry}
                        onSelect={(code) => setSelectedCountry(code)}
                        className="flag-container flex items-center justify-around py-2 h-11 bg-white focus-within:border focus-within:border-primary rounded-t-xl hover:shadow rounded-b-xl"
                        selectButtonClassName="w7 h-7"
                        id="icon-location"
                        searchable

                      />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >Company </label>
                      <input type="text" className="form-control" name='company' id="val-username" placeholder="" defaultValue={bookingType.company} />
                    </div>
                    <div className="col-xl-12 mb-3">
                      <label htmlFor="val-username" className="form-label" >VAT-ID  </label>
                      <input type="text" className="form-control" name='vat_id' id="val-username" placeholder="" defaultValue={bookingType.vat_id} />
                    </div>
                  </div>
                  <h5 style={{ color: 'red' }}>{error}</h5>
                  <div>
                    <button type="submit" className="btn btn-primary me-1">Submit</button>
                  </div>
                </form>
              </div>
            </div>
          </div>

        </div>

      </div>
      {isLoading && <LogoAnimationLoader />}
    </>
  );
};
export default EditBooking;